import StudentProgress from './StudentProgress';

export default StudentProgress;
